import { Route, Routes } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import { ThemeProvider } from 'styled-components';
import Catalog from './components/pages/catalog';
import Home from './components/pages/home';
import NotFound from './components/pages/not-found';
import { theme } from './theme';

function App() {
    return (
        <ThemeProvider theme={theme}>
            <RecoilRoot>
                <Routes>
                    <Route index element={<Home />} />
                    <Route path="katalog" element={<Catalog />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </RecoilRoot>
        </ThemeProvider>
    );
}

export default App;
